<template>
    <div v-if="sick" class="d-md-flex justify-content-md-between align-items-md-center alert alert-dashboard alert-danger mb-3">
        <div class="d-flex align-items-center">
            <span class="far fa-bell mr-4 d-none d-md-inline-flex"></span>
            <p class="mb-2 m-md-0 d-inline">Let op! Je staat nog geregistreerd als arbeidsongeschikt. Klopt dat?</p>
        </div>
        <div>
            <button type="button" class="btn btn-primary btn-red btn-sm" @click="submit()">Nee, ik ben weer in staat om te werken
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        route: String,
        sickProp: Boolean
    },
    data() {
        return {
            sick: this.sickProp
        };
    },
    methods: {
        submit() {
            if (!confirm('Ik wil me bij deze weer beter melden.')) {
                return false;
            }

            let that = this;

            this.axios.post(this.route)
                .then(function (response) {
                    that.sick = false;

                    that.$notify({
                        group: 'base',
                        text: 'U bent weer beter!',
                        type: 'alert-info',
                    });
                })
                .catch(function (error) {
                    that.$notify({
                        group: 'base',
                        text: 'Er is iets misgegaan met het beter melden. Vernieuw de pagina om de actuele status te zien.',
                        type: 'alert-danger',
                    });
                });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/BeterMelden.vue